export enum TypeOfPerson {
    JURIDICA = 'J',
    CONSORCIO = 'C',
    FISICA = 'F',
}